export enum PagePath {
  HotSpotsView = 'tile-grid',
  ReportView = 'report'
}
